class DetailsModal extends HTMLElement {
constructor() {
super();
this.detailsContainer = this.querySelector('details');
this.summaryToggle = this.querySelector('summary');
this.detailsContainer.addEventListener(
'keyup',
(event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
);
this.summaryToggle.addEventListener(
'click',
this.onSummaryClick.bind(this)
);
this.querySelector('[data-close-modal]').addEventListener(
'click',
this.close.bind(this)
);
this.summaryToggle.setAttribute('role', 'button');
}
isOpen() {
return this.detailsContainer.hasAttribute('open');
}
onSummaryClick(event) {
event.preventDefault();
event.target.closest('details').hasAttribute('open')
? this.close()
: this.open(event);
}
onBodyClick(event) {
if (!this.contains(event.target) || event.target.classList.contains('page-layout__overlay')) this.close(false);
}
open(event) {
if (this.dataset.documentClass) {
document.documentElement.classList.add(this.dataset.documentClass);
}
this.onBodyClickEvent =
this.onBodyClickEvent || this.onBodyClick.bind(this);
event.target.closest('details').setAttribute('open', true);
document.body.addEventListener('click', this.onBodyClickEvent);
setTimeout(() => {
trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'),
this.detailsContainer.querySelector('input:not([type="hidden"])'));
}, 100);
}
close(focusToggle = true) {
if (this.dataset.documentClass) {
document.documentElement.classList.remove(this.dataset.documentClass);
}
removeTrapFocus(focusToggle ? this.summaryToggle : null);
this.detailsContainer.removeAttribute('open');
document.body.removeEventListener('click', this.onBodyClickEvent);
}
}
customElements.define('details-modal', DetailsModal);